import Constants from 'Constants'
import Common from 'GroomyRoot/assets/js/common.js'

var SemenceMixin = {
	methods: {
		getStallions: async function() {
			const url = Constants.SEMENCE_STALLIONS_URL+"?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("SemenceMixin::getStallions", url)
			.catch(e => {
                console.error("SemenceMixin::getStallions => ", e)
                return null
			})
            
            if(result) return result.retour
            return null
        },
		getStockStallion: async function(stallion_id) {
			const url = this.constructRoute(Constants.SEMENCE_STALLION_STOCK_URL, {stallion_id})+"?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("SemenceMixin::getStockStallion", url)
			.catch(e => {
                console.error("SemenceMixin::getStockStallion => ", e)
                return null
			})
            
            if(result) return result.retour
            return null
        },
        getCommandeStallion: async function (stallion_id, status, type_date, start_date, end_date) {
			let url = this.constructRoute(Constants.SEMENCE_STALLION_COMMANDE_URL, {stallion_id})+"?licence_key="+Constants.USER_LICENCE_KEY+'&status='+status
			if(type_date) {
				url += '&type_date='+type_date.code+'&start_date='+start_date.toDateInputValue()+'&end_date='+end_date.toDateInputValue()
			}
			const result = await this.$request.request_get_api("CongelationMixin::getCommandeStallion", url)
			.catch(e => {
                console.error("CongelationMixin::getCommandeStallion => ", e)
                return null
			})

            if(result) return result.retour
            return []
		},
        getCommandes: async function (stallions_ids, status, type_date, start_date, end_date) {
			let url = Constants.SEMENCE_COMMANDE_URL+"?licence_key="+Constants.USER_LICENCE_KEY+'&status='+status
			if(stallions_ids.length > 0) {
				url += '&stallions_ids='+stallions_ids.join(',')
			}
			if(type_date) {
				url += '&type_date='+type_date.code+'&start_date='+start_date.toDateInputValue()+'&end_date='+end_date.toDateInputValue()
			}
			const result = await this.$request.request_get_api("CongelationMixin::getCommandes", url)
			.catch(e => {
                console.error("CongelationMixin::getCommandes => ", e)
                return null
			})

            if(result) return result.retour
            return []
		},
        getTiersDestinataire: async function () {
			let url = Constants.SEMENCE_TIERS_DESTINATAIRE_URL+"?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("CongelationMixin::getTiersDestinataire", url)
			.catch(e => {
                console.error("CongelationMixin::getTiersDestinataire => ", e)
                return null
			})

            if(result) return result.retour
            return []
		},
		addCommande: async function(params) {
			const url = Constants.SEMENCE_COMMANDE_URL+"?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_post_api("CongelationMixin::addCommande", url, params, false)
			.catch(e => {
                console.error("CongelationMixin::addCommande => ", e)
                return null
			})

            if(result) return result.retour
            return []
		},
    }
}

export default SemenceMixin
